import React, { Component } from 'react'
import Calculator from './Calculator'
import { History } from 'history'
import { withRouter } from 'react-router'
import cookie from 'react-cookies'
import { getUserData, getUserFeed, getTrainingDays } from '../../Api/backendApi'
// import { getAllUserWatchedVideos } from '../../Api/videoApi'
import { notify } from 'react-notify-toast'

import { hasDiet } from '../../Api/dietApi/userInfo'

import CalculatorView from './views/CalculatorView'

interface Props {
  push: Function
  history: History
  location: any
}

interface State {
  user: any
  openMenu: boolean
  actualPage: string
  isPlayerActive: boolean
  isSelectedValue: boolean
  activityMode: string
  BMRactivity: string
  userData: any
  isResultShown: boolean
  basicBMRResult: number
  fixedBMRResult: number
  proteinsKcal: number
  proteinsWeight: number
  carboKcal: number
  carboWeight: number
  fatKcal: number
  fatWeight: number
  isLoading: boolean
  userMail: string
  trainingDays: []
  allWatchedVids: []
  activeSubscriptionEndTime: string
  isUserLoggedIn: boolean
  userId: any
  isUserNewsletterSub: boolean
  isCreationDietMode: any
  userHasDiet: boolean
  weightError: boolean
  heightError: boolean
  ageError: boolean
  activityError: boolean
  isDemoAccount: boolean
  challengeMode: boolean
}

class CalculatorContainer extends Component<Props, State> {
  state: State = {
    user: {},
    openMenu: false,
    actualPage: '',
    isPlayerActive: false,
    isSelectedValue: false,
    activityMode: 'looseWeight',
    BMRactivity: '',
    userData: {},
    isResultShown: false,
    basicBMRResult: 0,
    fixedBMRResult: 0,
    proteinsKcal: 0,
    proteinsWeight: 0,
    carboKcal: 0,
    carboWeight: 0,
    fatKcal: 0,
    fatWeight: 0,
    isLoading: false,
    userMail: cookie.load('userEmail'),
    trainingDays: [],
    allWatchedVids: [],
    activeSubscriptionEndTime: '12-12-2020',
    isUserLoggedIn: cookie.load('accessToken') ? true : false,
    userId: 0,
    isUserNewsletterSub: false,
    isCreationDietMode: false,
    userHasDiet: false,
    weightError: false,
    heightError: false,
    ageError: false,
    activityError: false,
    isDemoAccount: cookie.load('userDemoMode'),
    challengeMode: this.props.location.challengeMode
  }

  componentDidMount = async () => {
    let userData: any = await getUserData()
    // let trainingDays: any = await getTrainingDays()
    // let allWatchedVids: any = await getAllUserWatchedVideos()
    let userHasDiet: any = await hasDiet()

    this.setState({
      user: userData,
      // trainingDays: trainingDays,
      // allWatchedVids: allWatchedVids,
      isUserNewsletterSub: userData.is_newsletter_subscriber,
      isCreationDietMode: this.props.location.creationDietMode
        ? this.props.location.creationDietMode
        : false,
      userHasDiet: userHasDiet,
    })
    // let userSubscription = await getUserSubscriptionInfo()

    this.setState({
      user: userData,
    })

    if (!this.state.isUserLoggedIn || this.state.user.name == '') {
      this.props.history.push('/')
    }
  }

  updateUserSubLocalChange = () => {
    this.setState({
      isUserNewsletterSub: !this.state.isUserNewsletterSub,
    })
  }

  logout = () => {
    cookie.remove('accessToken')
    cookie.remove('refreshToken')
    this.props.history.push('/')
  }

  onSelectActivity = (option: string) => {
    this.setState({
      activityMode: option,
    })
  }

  getInputValue = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.classList.contains('input-error')) {
      e.target.classList.remove('input-error')
    }

    const name = e.target.dataset.element
    if (this.state.userData) {
      await this.setState({
        userData: {
          ...this.state.userData,
          [name as any]: e.target.value,
        },
      })
    } else {
      await this.setState({
        userData: {
          [name as any]: e.target.value,
        },
      })
    }
  }

  onSelectDropdown = (selected: any) => {
    this.setState({
      isSelectedValue: true,
      BMRactivity: selected.value,
    })
  }

  onOpenMenuClick = () => {
    this.setState({
      openMenu: !this.state.openMenu,
    })
  }

  changeLocation = (location: string) => {
    this.props.history.push(location)
  }

  onSubpageChange = (page: string) => {
    this.setState({
      actualPage: page,
    })
  }

  closeMenu = () => {
    this.setState({
      openMenu: false,
    })
  }

  checkLastResult = () => { }

  calculateBMR = async () => {
    // BMR, czyli podstawowe zapotrzebowanie kaloryczne - [9,99 x masa ciała (kg)] + [6,25 x wzrost (cm)] - [4,92 x wiek(lata)] - 161
    let bmrResult: number = 0
    //  CPM, czyli całkowite zapotrzebowanie (przemianę materii), żeby to zrobić, musimy przypisać się do konkretnej wartości aktywności z tabeli poniżej
    let cpmResult: number = 0
    let lastResult: number = 0
    let proteinKcal: number = 0
    let proteinWeight: number = 0
    let fatKcal: number = 0
    let fatWeight: number = 0
    let carboKcal: number = 0
    let carboWeight: number = 0
    // 1,25  - brak aktywności, praca siedząca
    // 1,35 - niska aktywność (praca siedząca i 1-2 treningi w tygodniu)
    // 1,55 - średnia aktywność (praca siedząca i treningi 3-4 razy w tygodniu)
    // 1,75 - wysoka aktywność (praca fizyczna i 3-4 treningi w tygodniu)
    // 2,05 - bardzo wysoka aktywność (zawodowi sportowcy, osoby codziennie trenujące)
    // I na koniec pomnożyć BMR razy naszą, wybraną wartość aktywności.
    const userActivity: string = this.state.BMRactivity
    // Ostatnim krokiem jest wyznaczenie celu treningowego i ta opcja musi być także dostępna w kalkulatorze (jak w podanym wcześniej linku):
    // Jeżeli chcemy redukować, od wartości, która nam wyjdzie trzeba odjąć 200kcal/dobę.
    // Jeżeli chcemy budować masę mięśniową, powinnismy dodać około 250kcal/dobę.
    // Jeżeli chcemy utrzymać efekt - pozostajemy na wartości, która wyszła z mnożenia BMR x CPM
    const userTrenningTarget: string = this.state.activityMode
    // W obiekcie user data są właściwości o typie string, ktore trzeba parsowac do inta, właściwości: height, weight, age
    const userWeight: number = parseFloat(this.state.userData.weight)
    const userHeight: number = parseFloat(this.state.userData.height)
    const userAge: number = parseFloat(this.state.userData.age)

    if (!userWeight) {
      this.setState({
        weightError: true,
      })
      notify.show('Proszę wpisać wagę.', 'error', 2000)
    }

    if (!userHeight) {
      this.setState({
        heightError: true,
      })
      notify.show('Proszę wpisać wzrost.', 'error', 2000)
    }

    if (!userAge) {
      this.setState({
        ageError: true,
      })
      notify.show('Proszę wpisać wiek.', 'error', 2000)
    }

    if (!userActivity) {
      this.setState({
        activityError: true,
      })
      notify.show('Proszę wybrać preferowaną aktywność.', 'error', 2000)
    }

    if (userWeight && userHeight && userAge && userActivity) {
      bmrResult = 9.99 * userWeight + 6.25 * userHeight - 4.92 * userAge - 161

      await this.setState({
        basicBMRResult: bmrResult,
      })
      switch (userActivity) {
        case 'none':
          cpmResult = bmrResult * 1.2
          break
        case 'low':
          cpmResult = bmrResult * 1.35
          break
        case 'medium':
          cpmResult = bmrResult * 1.55
          break
        case 'high':
          cpmResult = bmrResult * 1.75
          break
        case 'veryHigh':
          cpmResult = bmrResult * 2.05
          break
        default:
          break
      }

      switch (userTrenningTarget) {
        case 'looseWeight':
          lastResult = cpmResult - 200
          break
        case 'keepWeight':
          lastResult = cpmResult
          break
        case 'gainWeight':
          lastResult = cpmResult + 250
          break
        default:
          break
      }

      // Calculate percentage of proteins, fat and carbo
      // protein
      proteinKcal = lastResult * 0.15
      proteinWeight = proteinKcal / 4.02
      // carbo
      carboKcal = lastResult * 0.55
      carboWeight = carboKcal / 4.02
      // fat
      fatKcal = lastResult * 0.3
      fatWeight = fatKcal / 9

      await this.setState({
        fixedBMRResult: lastResult,
        isResultShown: true,
        proteinsKcal: proteinKcal,
        proteinsWeight: proteinWeight,
        carboKcal: carboKcal,
        carboWeight: carboWeight,
        fatKcal: fatKcal,
        fatWeight: fatWeight,
      })
    }
  }

  render() {
    return (
      // <Calculator
      //   user={this.state.user}
      //   openMenu={this.state.openMenu}
      //   onOpenMenuClick={this.onOpenMenuClick}
      //   changeLocation={this.changeLocation}
      //   onSubpageChange={this.onSubpageChange}
      //   isPlayerActive={this.state.isPlayerActive}
      //   closeMenu={this.closeMenu}
      //   onSelectDropdown={this.onSelectDropdown}
      //   isSelectedValue={this.state.isSelectedValue}
      //   onSelectActivity={this.onSelectActivity}
      //   activityMode={this.state.activityMode}
      //   calculateBMR={this.calculateBMR}
      //   getInputValue={this.getInputValue}
      //   isResultShown={this.state.isResultShown}
      //   basicBMRResult={this.state.basicBMRResult}
      //   fixedBMRResult={this.state.fixedBMRResult}
      //   proteinsKcal={this.state.proteinsKcal}
      //   proteinsWeight={this.state.proteinsWeight}
      //   carboKcal={this.state.carboKcal}
      //   carboWeight={this.state.carboWeight}
      //   fatKcal={this.state.fatKcal}
      //   fatWeight={this.state.fatWeight}
      //   logout={this.logout}
      //   userMail={this.state.userMail}
      //   // trainingDays={this.state.trainingDays}
      //   // allWatchedVids={this.state.allWatchedVids}
      //   activeSubscriptionEndTime={this.state.activeSubscriptionEndTime}
      //   userId={this.state.userId}
      //   updateUserSubLocalChange={this.updateUserSubLocalChange}
      //   isUserNewsletterSub={this.state.isUserNewsletterSub}
      //   isCreationDietMode={this.state.isCreationDietMode}
      //   ageError={this.state.ageError}
      //   weightError={this.state.weightError}
      //   heightError={this.state.heightError}
      //   activityError={this.state.activityError}
      //   isDemoAccount={this.state.isDemoAccount}
      // />
      <CalculatorView
        creationDietMode={
          this.props.location.creationDietMode
            ? this.props.location.creationDietMode
            : false
        }
        challengeMode={this.state.challengeMode}
      />
    )
  }
}
export default withRouter(CalculatorContainer)
